import React from "react";
import LoadingAgreements from "./LoadingAgreements";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/pro-regular-svg-icons";

const ContactPerson = ({ contactPerson, bgColor = "bg-white" }) => {
  if (!contactPerson) return <LoadingAgreements />;

  return (
    <div
      key={contactPerson.contactPersonPublicId || "Contact"}
      className={`${bgColor} w-full min-w-[233px] rounded-lg shadow-md px-[2rem] py-[1rem] min-h-[10rem]`}
    >
      <h3 className="pb-[1rem]">{contactPerson.contactRole
              ? contactPerson.contactRole.charAt(0).toUpperCase() +
                contactPerson.contactRole.slice(1).toLowerCase()
              : "Diflex contact"}</h3>
      <div className="flex flex-row">
        <div className="h-[50px] w-[50px] min-w-[35px] min-h-[35px]">
          {contactPerson?.contactPersonProfileImageUrl ? <img
            src={contactPerson.contactPersonProfileImageUrl}
            alt={`${contactPerson.contactPersonName}`}
            className="rounded-full object-cover"
          />:
          <div className="flex items-center justify-center aspect-square h-[50px] w-[50px] min-w-[35px] min-h-[35px] rounded-full bg-primary-400 text-white">
            <FontAwesomeIcon icon={faUser}></FontAwesomeIcon>
          </div>
          }
        </div>
        <div className="pl-[1rem] flex flex-col">
   
          <p className="text-lg">{contactPerson.contactPersonName || "Unknown"}</p>
          <p className="text-primary-500 text-sm">
            {contactPerson.contactPersonPhone || "No phone"} | {" "}
            {(contactPerson.contactPersonEmail || "").toLowerCase() ? (
              <a href={`mailto:${contactPerson.contactPersonEmail}`} className="text-primary-500">
                {contactPerson.contactPersonEmail.toLowerCase()}
              </a>
            ) : (
              "No email"
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactPerson;
